import Config from '@config';
import { initializeBiDashboardsApi } from '@gasbi/shared/common/features';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  biDashboardsApi,
  useGetBiDashboardsQuery,
  useLazyGetBiDashboardEmbedTokenQuery,
} = initializeBiDashboardsApi({
  // Shared BiDashboardsController is mapped at the root (MapControllers), not under the /api group.
  baseUrl: `${Config.VITE_API_URL}/bi-dashboards`,
  baseQuery: axiosBaseQuery,
});
